import { connect } from 'react-redux';

import CognitoFormAddScreen from '../components/CognitoFormAddScreen';

const mapStateToProps = (state) => {
  return {
    isLoading: state.cognitoForms.get('isLoading'),
    success: state.cognitoForms.getIn(['form', 'success']),
  };
};

const CognitoFormAddScreenContainer =
  connect(mapStateToProps)(CognitoFormAddScreen);

export default CognitoFormAddScreenContainer;
